import { createApp } from 'vue'
import { createPinia } from 'pinia'

import router from '@/app/router'
import App from '@/app/App.vue'
import i18n from '@/app/services/i18n'
import dayjs from 'dayjs'
import localizedFormat from 'dayjs/plugin/localizedFormat'

import 'dayjs/locale/de'
import '@/app/assets/index.css'
import '@/app/assets/font/Floptop.css'

dayjs.extend(localizedFormat)

const pinia = createPinia()
const app = createApp(App)

app.use(i18n)
app.use(pinia)
app.use(router)
app.mount('#app')
